
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiAlertsActive as ObiAlertsActiveElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-alerts-active.js';
 
 
 

 
 export const ObiAlertsActive = createComponent({
   react: React,
   tagName: 'obi-alerts-active',
   elementClass: ObiAlertsActiveElement,
   events: {
     
   }
  });
 
 